import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event-Icons-/-Status-/-Error",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M21.5543345,8.25806452 L16,13.812399 L10.4456655,8.25806452 L8.25806452,10.4456655 L13.812399,16 L8.25806452,21.5543345 L10.4456655,23.7419355 L16,18.187601 L21.5543345,23.7419355 L23.7419355,21.5543345 L18.187601,16 L23.7419355,10.4456655 L21.5543345,8.25806452 Z",
    id: "Combined-Shape"
  })));
});